import React, { PropsWithChildren } from 'react';
import componentProps, { ComponentProps } from '../../../helpers/componentProps';
import { applyComponentTheme } from '../../../theme';
import fluidGridColumns from '../../../theme/fluidGridColumns';
import { CardColumnSpanCalculator, CardGrid } from '../../CardGrid';

const getDesktopColumnSpan = (totalCards: number): number => {
  const colSpanForSingleItemRow = 8;
  const colSpanForTwoItemRow = 6;
  const colSpanForThreeItemRow = 4;

  if (totalCards === 1) {
    return colSpanForSingleItemRow;
  }
  if (totalCards === 3) {
    return colSpanForThreeItemRow;
  }
  return colSpanForTwoItemRow;
};

export const columnSpanCalculator: CardColumnSpanCalculator = (
  index: number,
  totalCards: number
) => ({
  // mobile cards are always full-width
  tabletPortrait:
    totalCards === 1 || (totalCards === 3 && index === 0)
      ? fluidGridColumns.tabletPortrait
      : fluidGridColumns.tabletPortrait / 2,
  tabletLandscape: getDesktopColumnSpan(totalCards),
  desktop: getDesktopColumnSpan(totalCards),
});

export const leftAlignCalculator = (total: number): boolean => total !== 1;

const ActionCardGrid: React.FC<PropsWithChildren<ComponentProps>> = ({
  children,
  ...props
}) => (
  <CardGrid
    {...componentProps(props)}
    columnSpanCalculator={columnSpanCalculator}
    alignLeft={leftAlignCalculator(React.Children.count(children))}>
    {children}
  </CardGrid>
);

export default applyComponentTheme(ActionCardGrid, 'ActionCardGrid');
